module.exports = __webpack_public_path__ + "static/img/467aaf3369aea0bd0.3bc03e06.png";